/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner from './BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner';

/**
 * The BasketsValidatePost400ResponseValidationErrorsInner model module.
 * @module model/BasketsValidatePost400ResponseValidationErrorsInner
 * @version 1.0.0
 */
class BasketsValidatePost400ResponseValidationErrorsInner {
    /**
     * Constructs a new <code>BasketsValidatePost400ResponseValidationErrorsInner</code>.
     * @alias module:model/BasketsValidatePost400ResponseValidationErrorsInner
     */
    constructor() { 
        
        BasketsValidatePost400ResponseValidationErrorsInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsValidatePost400ResponseValidationErrorsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsValidatePost400ResponseValidationErrorsInner} obj Optional instance to populate.
     * @return {module:model/BasketsValidatePost400ResponseValidationErrorsInner} The populated <code>BasketsValidatePost400ResponseValidationErrorsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsValidatePost400ResponseValidationErrorsInner();

            if (data.hasOwnProperty('basket_item_id')) {
                obj['basket_item_id'] = ApiClient.convertToType(data['basket_item_id'], 'Number');
            }
            if (data.hasOwnProperty('promo_code')) {
                obj['promo_code'] = ApiClient.convertToType(data['promo_code'], 'String');
            }
            if (data.hasOwnProperty('coupon')) {
                obj['coupon'] = ApiClient.convertToType(data['coupon'], Object);
            }
            if (data.hasOwnProperty('email_address')) {
                obj['email_address'] = ApiClient.convertToType(data['email_address'], 'String');
            }
            if (data.hasOwnProperty('selected_customer_id')) {
                obj['selected_customer_id'] = ApiClient.convertToType(data['selected_customer_id'], 'String');
            }
            if (data.hasOwnProperty('selected_product_ids')) {
                obj['selected_product_ids'] = ApiClient.convertToType(data['selected_product_ids'], ['String']);
            }
            if (data.hasOwnProperty('coupon_key')) {
                obj['coupon_key'] = ApiClient.convertToType(data['coupon_key'], 'String');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], [BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsValidatePost400ResponseValidationErrorsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsValidatePost400ResponseValidationErrorsInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['promo_code'] && !(typeof data['promo_code'] === 'string' || data['promo_code'] instanceof String)) {
            throw new Error("Expected the field `promo_code` to be a primitive type in the JSON string but got " + data['promo_code']);
        }
        // ensure the json data is a string
        if (data['email_address'] && !(typeof data['email_address'] === 'string' || data['email_address'] instanceof String)) {
            throw new Error("Expected the field `email_address` to be a primitive type in the JSON string but got " + data['email_address']);
        }
        // ensure the json data is a string
        if (data['selected_customer_id'] && !(typeof data['selected_customer_id'] === 'string' || data['selected_customer_id'] instanceof String)) {
            throw new Error("Expected the field `selected_customer_id` to be a primitive type in the JSON string but got " + data['selected_customer_id']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['selected_product_ids'])) {
            throw new Error("Expected the field `selected_product_ids` to be an array in the JSON data but got " + data['selected_product_ids']);
        }
        // ensure the json data is a string
        if (data['coupon_key'] && !(typeof data['coupon_key'] === 'string' || data['coupon_key'] instanceof String)) {
            throw new Error("Expected the field `coupon_key` to be a primitive type in the JSON string but got " + data['coupon_key']);
        }
        if (data['errors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['errors'])) {
                throw new Error("Expected the field `errors` to be an array in the JSON data but got " + data['errors']);
            }
            // validate the optional field `errors` (array)
            for (const item of data['errors']) {
                BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} basket_item_id
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['basket_item_id'] = undefined;

/**
 * @member {String} promo_code
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['promo_code'] = undefined;

/**
 * @member {Object} coupon
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['coupon'] = undefined;

/**
 * @member {String} email_address
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['email_address'] = undefined;

/**
 * @member {String} selected_customer_id
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['selected_customer_id'] = undefined;

/**
 * @member {Array.<String>} selected_product_ids
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['selected_product_ids'] = undefined;

/**
 * @member {String} coupon_key
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['coupon_key'] = undefined;

/**
 * @member {Boolean} valid
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['valid'] = undefined;

/**
 * @member {Array.<module:model/BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner>} errors
 */
BasketsValidatePost400ResponseValidationErrorsInner.prototype['errors'] = undefined;






export default BasketsValidatePost400ResponseValidationErrorsInner;

